import { render, staticRenderFns } from "./viewSetting.vue?vue&type=template&id=fd0378c0&scoped=true"
import script from "./viewSetting.vue?vue&type=script&lang=js"
export * from "./viewSetting.vue?vue&type=script&lang=js"
import style0 from "./viewSetting.vue?vue&type=style&index=0&id=fd0378c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0378c0",
  null
  
)

export default component.exports